import { createAsyncThunk } from '@reduxjs/toolkit';
import { createFeed } from '../../../api/feeds';
import { routes } from '../../../constants/RouterPath';
import { createRequest } from '../../../helpers/api/createRequest';
import { Thunk } from '../../../helpers/redux/Thunk';
import { history } from '../../../store/history';
import { FeedBody } from '../../../types/Endpoints/feeds';
import { TypesIcon } from '../../../types/TypesIcon';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { addNotification } from '../../notifications';

export const CREATE_FEED = 'feeds/getFeed';

const onSuccess = (): Thunk => dispatch => {
    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Фид создан успешно',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));

    history.push(routes.feeds);
};

export const createFeedThunk = createAsyncThunk(
    CREATE_FEED,
    createRequest({
        type: CREATE_FEED,
        loader: async (body: FeedBody) => createFeed(body),
        onSuccess,
    }),
);
